module.exports = __webpack_public_path__ + "static/media/weekend_papers_footy2024.ed323955.webp";